var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#007F9B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 11)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 12,
    rx: 1.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3.5v6l5-3z",
    fill: "#1B5E20"
  }))));
}
export default SvgYoutube;